"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withNamedError;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _getHocName = _interopRequireDefault(require("../_utils/getHocName"));

var _errorsContext = _interopRequireDefault(require("./errorsContext"));

function resolveError(_ref, errors) {
  var name = _ref.name,
      error = _ref.error;

  if (error) {
    return error;
  }

  if (!name || !errors) {
    return null;
  }

  return errors[name];
}

function withNamedError(Wrapped) {
  var hoc = function hoc(props) {
    return _react.default.createElement(_errorsContext.default.Consumer, null, function (ctx) {
      return _react.default.createElement(Wrapped, (0, _extends2.default)({}, props, {
        error: resolveError(props, ctx)
      }));
    });
  };

  hoc.displayName = (0, _getHocName.default)('NamedError', Wrapped);
  return hoc;
}